import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock } from 'lucide-react';
export function OpeningHook() {
  return <section className="py-20 bg-white" data-id="element-56">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-57">
        <FadeIn data-id="element-58">
          <div className="flex items-center justify-center mb-8 text-terracotta" data-id="element-59">
            <Clock size={32} strokeWidth={1.5} data-id="element-60" />
          </div>
          <div className="prose prose-lg md:prose-xl mx-auto text-center" data-id="element-61">
            <p className="text-2xl md:text-3xl font-serif text-charcoal leading-relaxed mb-8" data-id="element-62">
              Son las 6:15 PM. Acabas de entrar por la puerta tras un día
              agotador. Sueltas las llaves y ahí está: platos en el fregadero,
              juguetes en el suelo y esa pregunta que retumba en tu cabeza como
              una alarma:{' '}
              <span className="italic text-terracotta" data-id="element-63">
                "¿Qué vamos a cenar hoy?"
              </span>
              .
            </p>
            <p className="text-warmgray font-light leading-relaxed" data-id="element-64">
              Sientes que el peso de la casa te aplasta. No es falta de ganas,
              es que tu cerebro ya no puede tomar ni una sola decisión más.
              Estás en el momento del colapso, y lo único que quieres es
              sentarte, pero el caos visual no te deja descansar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}